// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextWithTooltipItem-module__font-s-10___YFOHK {
  font-size: 10px !important;
}

.TextWithTooltipItem-module__font-s-12___llULb {
  font-size: 12px !important;
}

.TextWithTooltipItem-module__font-s-13___Ls1Rx {
  font-size: 13px !important;
}

.TextWithTooltipItem-module__font-s-14___iMIME {
  font-size: 14px !important;
}

.TextWithTooltipItem-module__font-s-15___ybzOx {
  font-size: 15px !important;
}

.TextWithTooltipItem-module__font-s-16___n_s_g {
  font-size: 16px !important;
}

.TextWithTooltipItem-module__font-s-18___AEQv6 {
  font-size: 18px !important;
}

.TextWithTooltipItem-module__font-s-20___tom1I {
  font-size: 20px !important;
}

.TextWithTooltipItem-module__font-s-22___kt1Lt {
  font-size: 22px !important;
}

.TextWithTooltipItem-module__font-s-28___cbd6F {
  font-size: 28px !important;
}

.TextWithTooltipItem-module__font-w-400___oBfU_ {
  font-weight: 400 !important;
}

.TextWithTooltipItem-module__font-w-500___cBeRE {
  font-weight: 500 !important;
}

.TextWithTooltipItem-module__font-w-600___kwD_e {
  font-weight: 600 !important;
}

.TextWithTooltipItem-module__font-w-700___jyqx7 {
  font-weight: 700 !important;
}

.TextWithTooltipItem-module__p-5___LiHf5 {
  padding: 5px !important;
}

.TextWithTooltipItem-module__p-12___wwGJ2 {
  padding: 12px !important;
}

.TextWithTooltipItem-module__p-16___TiLmE {
  padding: 16px !important;
}

.TextWithTooltipItem-module__p-30___h_n44 {
  padding: 30px !important;
}

.TextWithTooltipItem-module__p-b-0___qExfY {
  padding-bottom: 0 !important;
}

.TextWithTooltipItem-module__p-b-5___tlvYn {
  padding-bottom: 5px !important;
}

.TextWithTooltipItem-module__p-b-10___j0i0Y {
  padding-bottom: 10px !important;
}

.TextWithTooltipItem-module__p-b-12___y06rZ {
  padding-bottom: 12px !important;
}

.TextWithTooltipItem-module__p-b-16___jMRIt {
  padding-bottom: 16px !important;
}

.TextWithTooltipItem-module__p-b-18___M6iBK {
  padding-bottom: 18px !important;
}

.TextWithTooltipItem-module__p-b-20___b3sBv {
  padding-bottom: 20px !important;
}

.TextWithTooltipItem-module__p-b-25___FP34F {
  padding-bottom: 25px !important;
}

.TextWithTooltipItem-module__p-b-30___zicZ4 {
  padding-bottom: 30px !important;
}

.TextWithTooltipItem-module__p-b-50___BgCQN {
  padding-bottom: 50px !important;
}

.TextWithTooltipItem-module__p-t-0___EoXu_ {
  padding-top: 0 !important;
}

.TextWithTooltipItem-module__p-t-12___I6dOZ {
  padding-top: 12px !important;
}

.TextWithTooltipItem-module__p-t-16___w3vXh {
  padding-top: 16px !important;
}

.TextWithTooltipItem-module__p-t-18___m5EY7 {
  padding-top: 18px !important;
}

.TextWithTooltipItem-module__p-t-20___nBvR2 {
  padding-top: 20px !important;
}

.TextWithTooltipItem-module__p-t-30___aFPAo {
  padding-top: 30px !important;
}

.TextWithTooltipItem-module__p-t-40___RYtBv {
  padding-top: 40px !important;
}

.TextWithTooltipItem-module__p-t-50___NffHO {
  padding-top: 50px !important;
}

.TextWithTooltipItem-module__p-l-20___tvehX {
  padding-left: 20px !important;
}

.TextWithTooltipItem-module__p-l-30___lkEPG {
  padding-left: 30px !important;
}

.TextWithTooltipItem-module__p-l-40___D9vHT {
  padding-left: 40px !important;
}

.TextWithTooltipItem-module__p-r-16___RhuC5 {
  padding-right: 16px !important;
}

.TextWithTooltipItem-module__p-r-20___f8R62 {
  padding-right: 20px !important;
}

.TextWithTooltipItem-module__p-r-30___Bvbji {
  padding-right: 30px !important;
}

.TextWithTooltipItem-module__p-r-50___wR_b4 {
  padding-right: 50px !important;
}

.TextWithTooltipItem-module__p-r-60___FsM1W {
  padding-right: 60px !important;
}

.TextWithTooltipItem-module__m-b-1___qirZX {
  margin-bottom: 1px !important;
}

.TextWithTooltipItem-module__m-b-2___GmkuP {
  margin-bottom: 2px !important;
}

.TextWithTooltipItem-module__m-b-6___g8ZxB {
  margin-bottom: 6px !important;
}

.TextWithTooltipItem-module__m-b-8___seGF8 {
  margin-bottom: 8px !important;
}

.TextWithTooltipItem-module__m-b-10___u9utU {
  margin-bottom: 10px !important;
}

.TextWithTooltipItem-module__m-b-14___SyG3s {
  margin-bottom: 14px !important;
}

.TextWithTooltipItem-module__m-b-16___wMqjZ {
  margin-bottom: 16px !important;
}

.TextWithTooltipItem-module__m-b-20___mXEOb {
  margin-bottom: 20px !important;
}

.TextWithTooltipItem-module__m-b-22___YcpDm {
  margin-bottom: 22px !important;
}

.TextWithTooltipItem-module__m-b-24___eZFlx {
  margin-bottom: 24px !important;
}

.TextWithTooltipItem-module__m-b-30___HMY5o {
  margin-bottom: 30px !important;
}

.TextWithTooltipItem-module__m-b-32___onJoN {
  margin-bottom: 32px !important;
}

.TextWithTooltipItem-module__m-b-40___B5v2x {
  margin-bottom: 40px !important;
}

.TextWithTooltipItem-module__m-t-2___R5wHr {
  margin-top: 2px !important;
}

.TextWithTooltipItem-module__m-t-3___T1R5W {
  margin-top: 3px !important;
}

.TextWithTooltipItem-module__m-t-4___wnU1J {
  margin-top: 4px !important;
}

.TextWithTooltipItem-module__m-t-5___GOpHT {
  margin-top: 5px !important;
}

.TextWithTooltipItem-module__m-t-8___tBoiS {
  margin-top: 8px !important;
}

.TextWithTooltipItem-module__m-t-10___EWdqx {
  margin-top: 10px !important;
}

.TextWithTooltipItem-module__m-t-15___xDd34 {
  margin-top: 15px !important;
}

.TextWithTooltipItem-module__m-t-16___qWitC {
  margin-top: 16px !important;
}

.TextWithTooltipItem-module__m-t-20___OgozV {
  margin-top: 20px !important;
}

.TextWithTooltipItem-module__m-t-22___iG1we {
  margin-top: 22px !important;
}

.TextWithTooltipItem-module__m-t-30___o4xpC {
  margin-top: 30px !important;
}

.TextWithTooltipItem-module__m-t-32___O2C6N {
  margin-top: 32px !important;
}

.TextWithTooltipItem-module__m-l-auto___n2M9t {
  margin-left: auto !important;
}

.TextWithTooltipItem-module__m-l-4___Pf7cD {
  margin-left: 4px !important;
}

.TextWithTooltipItem-module__m-l-5___JeBZi {
  margin-left: 5px !important;
}

.TextWithTooltipItem-module__m-l-6___Vc2ff {
  margin-left: 6px !important;
}

.TextWithTooltipItem-module__m-l-8___Mwti6 {
  margin-left: 8px !important;
}

.TextWithTooltipItem-module__m-l-10___mKOtG {
  margin-left: 10px !important;
}

.TextWithTooltipItem-module__m-l-16___bQABJ {
  margin-left: 16px !important;
}

.TextWithTooltipItem-module__m-l-20___pkZtm {
  margin-left: 20px !important;
}

.TextWithTooltipItem-module__m-l-24___ZhhiD {
  margin-left: 24px !important;
}

.TextWithTooltipItem-module__m-l-30___ozdj7 {
  margin-left: 30px !important;
}

.TextWithTooltipItem-module__m-l-35___B6dwr {
  margin-left: 35px !important;
}

.TextWithTooltipItem-module__m-l-40___lxPFi {
  margin-left: 40px !important;
}

.TextWithTooltipItem-module__m-r-8___DsOBp {
  margin-right: 8px !important;
}

.TextWithTooltipItem-module__m-r-10___u6Xlt {
  margin-right: 10px !important;
}

.TextWithTooltipItem-module__m-r-16___L0xtG {
  margin-right: 16px !important;
}

.TextWithTooltipItem-module__m-r-20___TE7Yw {
  margin-right: 20px !important;
}

.TextWithTooltipItem-module__m-r-24___GFSVg {
  margin-right: 24px !important;
}

.TextWithTooltipItem-module__m-r-30___kF_oU {
  margin-right: 30px !important;
}

.TextWithTooltipItem-module__m-r-40___UZ64N {
  margin-right: 40px !important;
}

.TextWithTooltipItem-module__border-r-3___Daw5U {
  border-radius: 3px !important;
}

.TextWithTooltipItem-module__border-r-4___MXg5l {
  border-radius: 4px !important;
}

.TextWithTooltipItem-module__border-r-6____BAn9 {
  border-radius: 6px !important;
}

.TextWithTooltipItem-module__border-r-10___a8QjB {
  border-radius: 10px !important;
}

.TextWithTooltipItem-module__border-r-12___B3SJT {
  border-radius: 12px !important;
}

.TextWithTooltipItem-module__border-r-16___d0ogf {
  border-radius: 16px !important;
}

.TextWithTooltipItem-module__border-r-50___cC0Jl {
  border-radius: 50% !important;
}

.TextWithTooltipItem-module__primary-border___RBPsH {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TextWithTooltipItem-module__primary-border-b___GrBfD {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TextWithTooltipItem-module__primary-border-t___BuCBl {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TextWithTooltipItem-module__primary-border-l___OLbjq {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TextWithTooltipItem-module__primary-border-r___uhUZl {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TextWithTooltipItem-module__secondary-border___aCgpJ {
  border: 1px solid #637768;
}

.TextWithTooltipItem-module__secondary-border-b___Ilca2 {
  border-bottom: 1px solid #637768;
}

.TextWithTooltipItem-module__secondary-border-t___hfe_I {
  border-top: 1px solid #637768;
}

.TextWithTooltipItem-module__secondary-border-l___cBKi4 {
  border-left: 1px solid #637768;
}

.TextWithTooltipItem-module__secondary-border-r___KcpTY {
  border-right: 1px solid #637768;
}

.TextWithTooltipItem-module__gap-0___ND4Cj {
  gap: 0 !important;
}

.TextWithTooltipItem-module__gap-2___OyU_o {
  gap: 2px !important;
}

.TextWithTooltipItem-module__gap-4___BN0Dg {
  gap: 4px !important;
}

.TextWithTooltipItem-module__gap-5___yIY12 {
  gap: 5px !important;
}

.TextWithTooltipItem-module__gap-6___iyMAB {
  gap: 6px !important;
}

.TextWithTooltipItem-module__gap-8___jqiJb {
  gap: 8px !important;
}

.TextWithTooltipItem-module__gap-10___rCbk6 {
  gap: 10px !important;
}

.TextWithTooltipItem-module__gap-12___ISB1_ {
  gap: 12px !important;
}

.TextWithTooltipItem-module__gap-14___nBcyV {
  gap: 14px !important;
}

.TextWithTooltipItem-module__gap-16___ntQ6a {
  gap: 16px !important;
}

.TextWithTooltipItem-module__gap-18___Kry_y {
  gap: 18px !important;
}

.TextWithTooltipItem-module__gap-20___F7q9o {
  gap: 20px !important;
}

.TextWithTooltipItem-module__gap-24___GGtEe {
  gap: 24px !important;
}

.TextWithTooltipItem-module__gap-26___KqeDV {
  gap: 26px !important;
}

.TextWithTooltipItem-module__gap-30___I659O {
  gap: 30px !important;
}

.TextWithTooltipItem-module__gap-32___zcMaq {
  gap: 32px !important;
}

.TextWithTooltipItem-module__gap-40___CzYHt {
  gap: 40px !important;
}

.TextWithTooltipItem-module__gap-50___FYz7q {
  gap: 50px !important;
}

.TextWithTooltipItem-module__flex-1___ty9AD {
  flex: 1;
}

.TextWithTooltipItem-module__flex-none___dePKW {
  flex: none !important;
}

.TextWithTooltipItem-module__flex-column___JAx8R {
  display: flex;
  flex-direction: column !important;
}

.TextWithTooltipItem-module__flex-row___PIa3H {
  display: flex;
  flex-direction: row !important;
}

.TextWithTooltipItem-module__vertically-centered___FGlMD {
  display: flex;
  align-items: center !important;
}

.TextWithTooltipItem-module__horizontally-centered___rZh6z {
  display: flex;
  justify-content: center !important;
}

.TextWithTooltipItem-module__horizontally-end___CoifD {
  display: flex;
  justify-content: end !important;
}

.TextWithTooltipItem-module__vertically-start___lOE1p {
  display: flex;
  align-items: start !important;
}

.TextWithTooltipItem-module__space-between___ek2al {
  display: flex;
  justify-content: space-between !important;
}

.TextWithTooltipItem-module__flex-wrap___oZ2hd {
  flex-wrap: wrap !important;
}

.TextWithTooltipItem-module__height-100___puQTw {
  height: 100%;
}

.TextWithTooltipItem-module__width-50___Ro_Bp {
  width: 50% !important;
}

.TextWithTooltipItem-module__width-100___nHZwZ {
  width: 100%;
}

.TextWithTooltipItem-module__cursor-pointer___vgIeX {
  cursor: pointer;
}

.TextWithTooltipItem-module__cursor-not-allowed___uKptv {
  cursor: not-allowed !important;
}

.TextWithTooltipItem-module__absolute-centered___sfctG {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TextWithTooltipItem-module__absolute___xr_i7 {
  position: absolute;
}

.TextWithTooltipItem-module__relative___yamGk {
  position: relative;
}

.TextWithTooltipItem-module__fixed___R4Xmq {
  position: fixed;
}

.TextWithTooltipItem-module__visible___JI4I9 {
  opacity: 1;
}

.TextWithTooltipItem-module__invisible___MzUcq {
  opacity: 0;
}

.TextWithTooltipItem-module__col-90___KOdTy {
  width: 90% !important;
}

.TextWithTooltipItem-module__col-auto___J6ZfI {
  width: auto !important;
}

.TextWithTooltipItem-module__medical-tabs___teAcI {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TextWithTooltipItem-module__medical-table-new___wfTlN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN::-webkit-scrollbar-track {
  display: none;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN.TextWithTooltipItem-module__no-pagination___VTpTm {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN.TextWithTooltipItem-module__no-pagination___VTpTm:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN.TextWithTooltipItem-module__no-pagination___VTpTm::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TextWithTooltipItem-module__medical-table-new___wfTlN.TextWithTooltipItem-module__no-pagination___VTpTm::-webkit-scrollbar-track {
  display: none;
}

.TextWithTooltipItem-module__medical-table-empty___PuFqT {
  padding: 14px 40px !important;
}

.TextWithTooltipItem-module__icon-btn___VYmgq {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TextWithTooltipItem-module__search-icon___t_IoR {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TextWithTooltipItem-module__disable-select___l_43W {
  user-select: none;
}

.TextWithTooltipItem-module__break-word___spMbx {
  word-break: break-word;
}

.TextWithTooltipItem-module__popup-clear-btn___XicEZ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TextWithTooltipItem-module__scroll-m-b-20___gQliP {
  scroll-margin-bottom: 20px;
}

.TextWithTooltipItem-module__container___vbt4R {
  flex: 1;
}
.TextWithTooltipItem-module__container___vbt4R .TextWithTooltipItem-module__text___EaDWR {
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
  line-height: 150%;
  max-width: 250px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/TextWithTooltipItem/TextWithTooltipItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;AA8pBF;AA5pBE;EEqBA,+BApBO;EAqBP,gBAFmD;EFlBjD,cAAA;EACA,iBAAA;EACA,gBAAA;AA+pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n\n  .text {\n    @include get-font();\n    color: get-color(greenNew, dark);\n    line-height: 150%;\n    max-width: 250px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TextWithTooltipItem-module__font-s-10___YFOHK`,
	"fontS12": `TextWithTooltipItem-module__font-s-12___llULb`,
	"fontS13": `TextWithTooltipItem-module__font-s-13___Ls1Rx`,
	"fontS14": `TextWithTooltipItem-module__font-s-14___iMIME`,
	"fontS15": `TextWithTooltipItem-module__font-s-15___ybzOx`,
	"fontS16": `TextWithTooltipItem-module__font-s-16___n_s_g`,
	"fontS18": `TextWithTooltipItem-module__font-s-18___AEQv6`,
	"fontS20": `TextWithTooltipItem-module__font-s-20___tom1I`,
	"fontS22": `TextWithTooltipItem-module__font-s-22___kt1Lt`,
	"fontS28": `TextWithTooltipItem-module__font-s-28___cbd6F`,
	"fontW400": `TextWithTooltipItem-module__font-w-400___oBfU_`,
	"fontW500": `TextWithTooltipItem-module__font-w-500___cBeRE`,
	"fontW600": `TextWithTooltipItem-module__font-w-600___kwD_e`,
	"fontW700": `TextWithTooltipItem-module__font-w-700___jyqx7`,
	"p5": `TextWithTooltipItem-module__p-5___LiHf5`,
	"p12": `TextWithTooltipItem-module__p-12___wwGJ2`,
	"p16": `TextWithTooltipItem-module__p-16___TiLmE`,
	"p30": `TextWithTooltipItem-module__p-30___h_n44`,
	"pB0": `TextWithTooltipItem-module__p-b-0___qExfY`,
	"pB5": `TextWithTooltipItem-module__p-b-5___tlvYn`,
	"pB10": `TextWithTooltipItem-module__p-b-10___j0i0Y`,
	"pB12": `TextWithTooltipItem-module__p-b-12___y06rZ`,
	"pB16": `TextWithTooltipItem-module__p-b-16___jMRIt`,
	"pB18": `TextWithTooltipItem-module__p-b-18___M6iBK`,
	"pB20": `TextWithTooltipItem-module__p-b-20___b3sBv`,
	"pB25": `TextWithTooltipItem-module__p-b-25___FP34F`,
	"pB30": `TextWithTooltipItem-module__p-b-30___zicZ4`,
	"pB50": `TextWithTooltipItem-module__p-b-50___BgCQN`,
	"pT0": `TextWithTooltipItem-module__p-t-0___EoXu_`,
	"pT12": `TextWithTooltipItem-module__p-t-12___I6dOZ`,
	"pT16": `TextWithTooltipItem-module__p-t-16___w3vXh`,
	"pT18": `TextWithTooltipItem-module__p-t-18___m5EY7`,
	"pT20": `TextWithTooltipItem-module__p-t-20___nBvR2`,
	"pT30": `TextWithTooltipItem-module__p-t-30___aFPAo`,
	"pT40": `TextWithTooltipItem-module__p-t-40___RYtBv`,
	"pT50": `TextWithTooltipItem-module__p-t-50___NffHO`,
	"pL20": `TextWithTooltipItem-module__p-l-20___tvehX`,
	"pL30": `TextWithTooltipItem-module__p-l-30___lkEPG`,
	"pL40": `TextWithTooltipItem-module__p-l-40___D9vHT`,
	"pR16": `TextWithTooltipItem-module__p-r-16___RhuC5`,
	"pR20": `TextWithTooltipItem-module__p-r-20___f8R62`,
	"pR30": `TextWithTooltipItem-module__p-r-30___Bvbji`,
	"pR50": `TextWithTooltipItem-module__p-r-50___wR_b4`,
	"pR60": `TextWithTooltipItem-module__p-r-60___FsM1W`,
	"mB1": `TextWithTooltipItem-module__m-b-1___qirZX`,
	"mB2": `TextWithTooltipItem-module__m-b-2___GmkuP`,
	"mB6": `TextWithTooltipItem-module__m-b-6___g8ZxB`,
	"mB8": `TextWithTooltipItem-module__m-b-8___seGF8`,
	"mB10": `TextWithTooltipItem-module__m-b-10___u9utU`,
	"mB14": `TextWithTooltipItem-module__m-b-14___SyG3s`,
	"mB16": `TextWithTooltipItem-module__m-b-16___wMqjZ`,
	"mB20": `TextWithTooltipItem-module__m-b-20___mXEOb`,
	"mB22": `TextWithTooltipItem-module__m-b-22___YcpDm`,
	"mB24": `TextWithTooltipItem-module__m-b-24___eZFlx`,
	"mB30": `TextWithTooltipItem-module__m-b-30___HMY5o`,
	"mB32": `TextWithTooltipItem-module__m-b-32___onJoN`,
	"mB40": `TextWithTooltipItem-module__m-b-40___B5v2x`,
	"mT2": `TextWithTooltipItem-module__m-t-2___R5wHr`,
	"mT3": `TextWithTooltipItem-module__m-t-3___T1R5W`,
	"mT4": `TextWithTooltipItem-module__m-t-4___wnU1J`,
	"mT5": `TextWithTooltipItem-module__m-t-5___GOpHT`,
	"mT8": `TextWithTooltipItem-module__m-t-8___tBoiS`,
	"mT10": `TextWithTooltipItem-module__m-t-10___EWdqx`,
	"mT15": `TextWithTooltipItem-module__m-t-15___xDd34`,
	"mT16": `TextWithTooltipItem-module__m-t-16___qWitC`,
	"mT20": `TextWithTooltipItem-module__m-t-20___OgozV`,
	"mT22": `TextWithTooltipItem-module__m-t-22___iG1we`,
	"mT30": `TextWithTooltipItem-module__m-t-30___o4xpC`,
	"mT32": `TextWithTooltipItem-module__m-t-32___O2C6N`,
	"mLAuto": `TextWithTooltipItem-module__m-l-auto___n2M9t`,
	"mL4": `TextWithTooltipItem-module__m-l-4___Pf7cD`,
	"mL5": `TextWithTooltipItem-module__m-l-5___JeBZi`,
	"mL6": `TextWithTooltipItem-module__m-l-6___Vc2ff`,
	"mL8": `TextWithTooltipItem-module__m-l-8___Mwti6`,
	"mL10": `TextWithTooltipItem-module__m-l-10___mKOtG`,
	"mL16": `TextWithTooltipItem-module__m-l-16___bQABJ`,
	"mL20": `TextWithTooltipItem-module__m-l-20___pkZtm`,
	"mL24": `TextWithTooltipItem-module__m-l-24___ZhhiD`,
	"mL30": `TextWithTooltipItem-module__m-l-30___ozdj7`,
	"mL35": `TextWithTooltipItem-module__m-l-35___B6dwr`,
	"mL40": `TextWithTooltipItem-module__m-l-40___lxPFi`,
	"mR8": `TextWithTooltipItem-module__m-r-8___DsOBp`,
	"mR10": `TextWithTooltipItem-module__m-r-10___u6Xlt`,
	"mR16": `TextWithTooltipItem-module__m-r-16___L0xtG`,
	"mR20": `TextWithTooltipItem-module__m-r-20___TE7Yw`,
	"mR24": `TextWithTooltipItem-module__m-r-24___GFSVg`,
	"mR30": `TextWithTooltipItem-module__m-r-30___kF_oU`,
	"mR40": `TextWithTooltipItem-module__m-r-40___UZ64N`,
	"borderR3": `TextWithTooltipItem-module__border-r-3___Daw5U`,
	"borderR4": `TextWithTooltipItem-module__border-r-4___MXg5l`,
	"borderR6": `TextWithTooltipItem-module__border-r-6____BAn9`,
	"borderR10": `TextWithTooltipItem-module__border-r-10___a8QjB`,
	"borderR12": `TextWithTooltipItem-module__border-r-12___B3SJT`,
	"borderR16": `TextWithTooltipItem-module__border-r-16___d0ogf`,
	"borderR50": `TextWithTooltipItem-module__border-r-50___cC0Jl`,
	"primaryBorder": `TextWithTooltipItem-module__primary-border___RBPsH`,
	"primaryBorderB": `TextWithTooltipItem-module__primary-border-b___GrBfD`,
	"primaryBorderT": `TextWithTooltipItem-module__primary-border-t___BuCBl`,
	"primaryBorderL": `TextWithTooltipItem-module__primary-border-l___OLbjq`,
	"primaryBorderR": `TextWithTooltipItem-module__primary-border-r___uhUZl`,
	"secondaryBorder": `TextWithTooltipItem-module__secondary-border___aCgpJ`,
	"secondaryBorderB": `TextWithTooltipItem-module__secondary-border-b___Ilca2`,
	"secondaryBorderT": `TextWithTooltipItem-module__secondary-border-t___hfe_I`,
	"secondaryBorderL": `TextWithTooltipItem-module__secondary-border-l___cBKi4`,
	"secondaryBorderR": `TextWithTooltipItem-module__secondary-border-r___KcpTY`,
	"gap0": `TextWithTooltipItem-module__gap-0___ND4Cj`,
	"gap2": `TextWithTooltipItem-module__gap-2___OyU_o`,
	"gap4": `TextWithTooltipItem-module__gap-4___BN0Dg`,
	"gap5": `TextWithTooltipItem-module__gap-5___yIY12`,
	"gap6": `TextWithTooltipItem-module__gap-6___iyMAB`,
	"gap8": `TextWithTooltipItem-module__gap-8___jqiJb`,
	"gap10": `TextWithTooltipItem-module__gap-10___rCbk6`,
	"gap12": `TextWithTooltipItem-module__gap-12___ISB1_`,
	"gap14": `TextWithTooltipItem-module__gap-14___nBcyV`,
	"gap16": `TextWithTooltipItem-module__gap-16___ntQ6a`,
	"gap18": `TextWithTooltipItem-module__gap-18___Kry_y`,
	"gap20": `TextWithTooltipItem-module__gap-20___F7q9o`,
	"gap24": `TextWithTooltipItem-module__gap-24___GGtEe`,
	"gap26": `TextWithTooltipItem-module__gap-26___KqeDV`,
	"gap30": `TextWithTooltipItem-module__gap-30___I659O`,
	"gap32": `TextWithTooltipItem-module__gap-32___zcMaq`,
	"gap40": `TextWithTooltipItem-module__gap-40___CzYHt`,
	"gap50": `TextWithTooltipItem-module__gap-50___FYz7q`,
	"flex1": `TextWithTooltipItem-module__flex-1___ty9AD`,
	"flexNone": `TextWithTooltipItem-module__flex-none___dePKW`,
	"flexColumn": `TextWithTooltipItem-module__flex-column___JAx8R`,
	"flexRow": `TextWithTooltipItem-module__flex-row___PIa3H`,
	"verticallyCentered": `TextWithTooltipItem-module__vertically-centered___FGlMD`,
	"horizontallyCentered": `TextWithTooltipItem-module__horizontally-centered___rZh6z`,
	"horizontallyEnd": `TextWithTooltipItem-module__horizontally-end___CoifD`,
	"verticallyStart": `TextWithTooltipItem-module__vertically-start___lOE1p`,
	"spaceBetween": `TextWithTooltipItem-module__space-between___ek2al`,
	"flexWrap": `TextWithTooltipItem-module__flex-wrap___oZ2hd`,
	"height100": `TextWithTooltipItem-module__height-100___puQTw`,
	"width50": `TextWithTooltipItem-module__width-50___Ro_Bp`,
	"width100": `TextWithTooltipItem-module__width-100___nHZwZ`,
	"cursorPointer": `TextWithTooltipItem-module__cursor-pointer___vgIeX`,
	"cursorNotAllowed": `TextWithTooltipItem-module__cursor-not-allowed___uKptv`,
	"absoluteCentered": `TextWithTooltipItem-module__absolute-centered___sfctG`,
	"absolute": `TextWithTooltipItem-module__absolute___xr_i7`,
	"relative": `TextWithTooltipItem-module__relative___yamGk`,
	"fixed": `TextWithTooltipItem-module__fixed___R4Xmq`,
	"visible": `TextWithTooltipItem-module__visible___JI4I9`,
	"invisible": `TextWithTooltipItem-module__invisible___MzUcq`,
	"col90": `TextWithTooltipItem-module__col-90___KOdTy`,
	"colAuto": `TextWithTooltipItem-module__col-auto___J6ZfI`,
	"medicalTabs": `TextWithTooltipItem-module__medical-tabs___teAcI`,
	"medicalTableNew": `TextWithTooltipItem-module__medical-table-new___wfTlN`,
	"noPagination": `TextWithTooltipItem-module__no-pagination___VTpTm`,
	"medicalTableEmpty": `TextWithTooltipItem-module__medical-table-empty___PuFqT`,
	"iconBtn": `TextWithTooltipItem-module__icon-btn___VYmgq`,
	"searchIcon": `TextWithTooltipItem-module__search-icon___t_IoR`,
	"disableSelect": `TextWithTooltipItem-module__disable-select___l_43W`,
	"breakWord": `TextWithTooltipItem-module__break-word___spMbx`,
	"popupClearBtn": `TextWithTooltipItem-module__popup-clear-btn___XicEZ`,
	"scrollMB20": `TextWithTooltipItem-module__scroll-m-b-20___gQliP`,
	"container": `TextWithTooltipItem-module__container___vbt4R`,
	"text": `TextWithTooltipItem-module__text___EaDWR`
};
module.exports = ___CSS_LOADER_EXPORT___;
